var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92969 16H16.9297V8H8.92969V16ZM12.9297 22C11.5464 22 10.2464 21.7373 9.02969 21.212C7.81302 20.6873 6.75469 19.975 5.85469 19.075C4.95469 18.175 4.24235 17.1167 3.71769 15.9C3.19235 14.6833 2.92969 13.3833 2.92969 12C2.92969 10.6167 3.19235 9.31667 3.71769 8.1C4.24235 6.88333 4.95469 5.825 5.85469 4.925C6.75469 4.025 7.81302 3.31233 9.02969 2.787C10.2464 2.26233 11.5464 2 12.9297 2C14.313 2 15.613 2.26233 16.8297 2.787C18.0464 3.31233 19.1047 4.025 20.0047 4.925C20.9047 5.825 21.617 6.88333 22.1417 8.1C22.667 9.31667 22.9297 10.6167 22.9297 12C22.9297 13.3833 22.667 14.6833 22.1417 15.9C21.617 17.1167 20.9047 18.175 20.0047 19.075C19.1047 19.975 18.0464 20.6873 16.8297 21.212C15.613 21.7373 14.313 22 12.9297 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.6eec5e3dc8f863382192b1df2e07b968.svg";
export { ForwardRef as ReactComponent };